import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { connectStorageEmulator, getStorage } from 'firebase/storage'
import { installFirestoreRecovery } from './firestoreRecovery'

// Container deployments inject the config at startup via /config.js
// (window.__FIREBASE_CONFIG__); otherwise it is baked in at build time.
const firebaseConfig =
  window.__FIREBASE_CONFIG__ ??
  JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG ?? 'null')

console.log('firebaseConfig', firebaseConfig)

if (!firebaseConfig) {
  throw new Error(
    'Firebase config is not set. Please check your .env file if development, the vercel environment variables on Vercel, or the FIREBASE_* environment variables of the container.',
  )
}

installFirestoreRecovery()

export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const functions = getFunctions(app)
export const storage = getStorage(app)

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
  // Zod's `.optional()` produces `undefined` for unset fields, and Firestore
  // reads back missing fields as `undefined` — but writes reject `undefined`
  // unless this is enabled. Without it, any form with an optional field that
  // the user leaves blank fails the entire setDoc.
  ignoreUndefinedProperties: true,
})

// Use emulators in development mode
if (import.meta.env.VITE_USE_EMULATORS === 'true') {
  console.log('Using emulators')
  connectFirestoreEmulator(db, 'localhost', 8080)
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
  connectFunctionsEmulator(functions, 'localhost', 5001)
  connectStorageEmulator(storage, 'localhost', 9199)
}
